<!-- 工程案例详情 -->
<template>
    <div>
        <div class="cover" :style="{ backgroundImage: 'url('+img_api +pageData.bannerImg + ')' }">
            <div class="front">
                <div class="title">
                    <div class="big_title">
                        {{ pageData.firstTitle }} </div>
                    <div class="transparent_title">{{
                        pageData.secondTitle }}
                    </div>
                </div>
                <div class="des">
                    {{ pageData.des }}
                </div>
            </div>
        </div>
        <div class="bread_box">
            <div class="crumb"><span class="your_position">您所在的位置:</span>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/build' }">{{ pageData.firstTitle }}{{
                        pageData.secondTitle }} </el-breadcrumb-item>
                    <el-breadcrumb-item>详情</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="head">
            <div class="return_button" @click="goBack">返回列表页</div>
            <div class="news_data">
                <div class="news_title">{{ contentList.name }}</div>
            </div>
        </div>
        <div class="news_page">
            <div class="news_content">
                <div class="big_img_box">
                    <img class="big_img" :src="img_api +img" alt="">
                    <div class="right_btn" @click="next_img">
                        <img src="../assets/img/right_btn.png" alt="">
                    </div>
                    <div class="left_btn" @click="return_img">
                        <img src="../assets/img/left_btn.png" alt="">
                    </div>
                    <div class="sum">
                        {{ tabIndex }} /{{contentList.imageList.length }}
                    </div>
                </div>
                <div class="small_img_box">
                    <div class="small_img" v-for="img in  contentList.imageList " :key="img.id" @click="toBig(img)"
                        :class="img.id == tabIndex ? ' blue_border' : ''">
                        <img :src="img_api +img.url" alt="">
                    </div>
                </div>
                <p class="content_front">
                    {{ contentList.brief }}
                </p>
            </div>
        </div>
        <div class="content_bottom" v-show="chooseImg.length">
            <div class="tab_content">
                <div class="tabs">
                    <div class="blue">相关案例</div>
                </div>
                <div class="content_right_btn" @click="next_content_img">
                    <img src="../assets/img/right_btn.png" alt="">
                </div>
                <div class="content_left_btn" @click="return_content_img">
                    <img src="../assets/img/left_btn.png" alt="">
                </div>
                <div class="contents">
                    <div class="contents_img_box" ref="contents_img_box">
                        <projectBox v-for="(item, index) in chooseImg" :key="index" :project="item" @click.native="toProjectCase(item.id)"></projectBox>
                    </div>
                </div>
            </div>
            <button class="btn" @click="toContact">在线咨询&gt;&gt; </button>
        </div>
    </div>
</template>

<script>
import { getCaseDetails } from "@/server/https.js";
import projectBox from "../components/projectBox.vue";
export default {
  name: "",
  components: {
    projectBox,
  },
  data() {
    return {
      tabIndex: 1,
      img: "",
      contentList: {},
      pageData: {
        firstTitle: "",
        secondTitle: "",
        bannerImg: "",
        des: "",
      },
      chooseImg: [],
      imgList: [],
      img_api: 'https://www.gdyuanwo.com/gdyuanwo/',
    };
  },
  created(){
    getCaseDetails({ id: this.$route.query.id }).then((res) => {
      while (this.chooseImg.length < 3 && res.data.body.data.children.length > 0) {
      const element = res.data.body.data.children.shift(); // 移除首个元素
      this.chooseImg.push(element); // 添加到小数组末尾
    }
      this.contentList = res.data.body.data;
      this.img = res.data.body.data.imageList[0].url;
    });
  },
  mounted() {
    var setI = setInterval(() => {
      if (this.$store.state.headList != "") {
        var headList = this.$store.state.headList;
        headList.map((item) => {
          if (item.sort == 6) {
            let Name = item.name;
            this.pageData.firstTitle = Name.slice(0, -2);
            this.pageData.secondTitle = Name.substr(-2);
            this.pageData.bannerImg = item.image;
            this.pageData.des = item.details;
          }
        });
        clearInterval(setI);
      }
    }, 200);
  },
  methods: {
    //上一张图片
    return_content_img() {
      if (this.contentList.children.length >= 1) {
        //获取要放入小数组的元素,把它在大数组里去掉
        const element = this.contentList.children.pop();
        const element2 = this.chooseImg.pop();
        this.chooseImg.unshift(element);
        //去掉小数组的首个元素
        this.contentList.children.unshift(element2);
      }
    },
    //下一张图片
    next_content_img() {
      if (this.contentList.children.length >= 1) {
        //获取要放入小数组的元素
        const element = this.contentList.children.shift();
        //去掉小数组的首个元素
        const element2 = this.chooseImg.shift();

        this.chooseImg.push(element);
        this.contentList.children.push(element2);
      }
    },
    //返回上一层
    goBack() {
      this.$router.push({
           path: '/build',
        });
    },
    //点击缩略图
    toBig(item) {
      this.tabIndex = item.id;
      this.img = item.url;
    },
    //下一张图片
    next_img() {
      if (this.tabIndex < this.contentList.imageList.length) {
        this.tabIndex++;
        let object1 = this.contentList.imageList.find(
          (element) => element.id == this.tabIndex
        );
        this.img = object1.url;
      }
    },
    //上一张图片
    return_img() {
      if (this.tabIndex > 1) {
        this.tabIndex--;
        let object1 = this.contentList.imageList.find(
          (element) => element.id == this.tabIndex
        );
        this.img = object1.url;
      }
    },
    toProjectCase(index){
      this.$router.push({
           name: 'projectCase',
           query: { id: index }
        });
    },
    toContact(){
      this.$router.push({
           name: 'Contact',
        });
    }
  },
  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = true;
    next(0);
  },
};
</script>

<style scoped>
.cover {
  overflow: hidden;
  background: no-repeat;
  background-size: 100% 100%;
  height: 355px;
}

.front {
  margin-top: 72px;
  margin-left: 240px;
}

.head {
  display: flex;
  justify-content: space-between;
  margin-top: 52px;
  padding-bottom: 38px;
}

.news_title {
  font-size: 24px;
  font-weight: 500;
  color: #333333;
  margin-right: 20px;
}

.news_data {
  display: flex;
  align-items: center;
  margin: auto;
}

.return_button {
  width: 140px;
  height: 48px;
  background: #ffffff;
  border: 1px solid #5877ba;
  font-size: 18px;
  font-weight: 400;
  color: #13489d;
  line-height: 48px;
  text-align: center;
  position: absolute;
  left: 170px; 
   cursor: pointer;

}


.title {
  display: flex;
}

.big_title {
  font-size: 68px;
  font-weight: bold;
  color: #ffffff;
}

.transparent_title {
  font-size: 68px;
  font-weight: bold;
  color: rgba(255, 255, 255, 0);
  color: rgba(255, 255, 255, 0);
  -webkit-text-stroke: 1px #ffffff;
  text-stroke: 1px #ffffff;
}

.des {
  font-size: 24px;
  color: #ffffff;
}

.bread_box {
  overflow: hidden;
  height: 60px;
  background-color: #f7f8fa;
}

.crumb {
  display: flex;
  margin-top: 23px;
  margin-left: 140px;
}

.your_position {
  line-height: 1;
  font-size: 14px;
  font-weight: 400;
  color: #13489d;
  margin-right: 5px;
}

.content_row {
  display: flex;
  width: 100%;
  height: 15px;
  margin: 10px 0;
}

.content_title {
  line-height: 15px;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}

.colum {
  width: 5px;
  height: 100%;
  margin-right: 20px;
  background-color: #13489d;
}

.news_page {
  width: 1000px;
  margin: auto;
}

.news_type {
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  display: flex;
  align-items: center;
}

.looks_num {
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  margin-left: 40px;
}

.head {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  padding-bottom: 20px;
}

.news_title {
  font-size: 24px;
  font-weight: 500;
  color: #333333;
  margin-right: 20px;
}

.news_data {
  display: flex;
  align-items: center;
  margin: auto;
}


.news_content {
  margin-top: 20px;
}

.big_img_box {
  position: relative;
  display: flex;
  width: 100%;
  height: 600px;
}

.big_img {
  width: 100%;
  height: 100%;
}

.small_img_box {
  display: flex;
  margin-top: 20px;
  width: 100%;
  height: 72px;
  /* background-color: rgb(249, 144, 144); */
}

.small_img {
  width: 96px;
  height: 72px;
  margin-right: 10px;
  border: 2px solid #eeeeee;
}

.blue {
  color: #13489d;
  border-bottom: 4px solid #13489d;
}

.blue_border {
  border: 3px solid #13489d;
}

.small_img img {
  width: 100%;
  height: 100%;
}

.right_btn {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translate(10px, -30px);
  z-index: 2200;
  width: 35px;
  height: 35px;
}

.right_btn img {
  width: 100%;
  height: 100%;
}

.left_btn img {
  width: 100%;
  height: 100%;
}

.content_right_btn img {
  width: 100%;
  height: 100%;
}

.content_left_btn img {
  /* width: 100%; */
  height: 100%;
}

/* 底下轮播图按钮 */
.content_right_btn {
  position: absolute;
  /* transform: translate(2px, -26px); */
  top: 50%;
  right: 0;
  z-index: 2200;
  width: 30px;
  height: 30px;
}

.left_btn {
  position: absolute;
  top: 50%;
  transform: translate(10px, -30px);
  z-index: 2200;
  width: 35px;
  height: 35px;
}

.content_left_btn {
  float: left;
  position: absolute;
  top: 50%;
  z-index: 2200;
  width: 30px;
  height: 30px;
}

.sum {
  position: absolute;
  bottom: 10px;
  right: 20px;
  width: 48px;
  height: 26px;
  background: #000000;
  border-radius: 13px;
  opacity: 0.24;
  text-align: center;
  line-height: 26px;
  color: #ffffff;
}

.content_front {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  text-indent: 25px;
  line-height: 2;
  margin-top: 30px;
  margin-bottom: 100px;
}

.content_bottom {
  overflow: hidden;
  position: relative;
  width: 100%;
  margin: 30px auto;
  background-color: #f9f9fd;
  padding-bottom: 100px;
}

.tab_content {
  position: relative;
  width: 62.5rem;
  /* height: 1000px; */
  margin: 30px auto;
  background-color: #fff;
}

.tabs {
  height: 60px;
  line-height: 60px;
  display: flex;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  border-bottom: 1px solid rgba(153, 153, 153, 0.3);
}

.tabs div {
  margin-left: 40px;
}

.contents {
  position: relative;
  width: 955px;
  height: 100%;
  padding-bottom: 100px;
  margin-left: 25px;
  margin-top: 70px;
  display: flex;
  flex-shrink: 0;
  overflow: hidden;
  /* background-color: rgb(238, 108, 108); */
}

.btn {
  position: absolute;
  width: 140px;
  height: 48px;
  left: 0;
  right: 0;
  background: #13489d;
  font-weight: 400;
  color: #ffffff;
  margin: auto;
}

.pag {
  float: right;
  margin-bottom: 40px;
  margin-right: 200px;
}

.contents_img_box {
  display: flex;
  flex-shrink: 0;
  flex-wrap: nowrap;
}
</style>
